import { TourProvider as ReactTourProvider } from '@reactour/tour';
import type { ReactNode } from 'react';

/**
 * React Tour Provider with custom design
 * @param props - React node
 * @returns TourProvider
 */
export function TourProvider({ children }: { children: ReactNode }) {
  return (
    <ReactTourProvider
      showCloseButton={false}
      steps={[]}
      styles={{
        popover: (base) => ({
          ...base,
          maxWidth: '600px',
          background: 'rgb(222, 222, 222)',
          borderRadius: 10,
        }),
        maskArea: (base) => ({ ...base, rx: 10 }),
        arrow: (base, state) => ({
          ...base,
          width: '2rem',
          height: '2rem',
          color: state?.disabled ? '#caccce' : '#131313',
        }),
        dot: (base, state) => ({
          ...base,
          background: state?.current ? '#2E71F9' : '#9E9E9E',
        }),
      }}
      onClickMask={({ setCurrentStep, currentStep, steps, setIsOpen }) => {
        if (steps) {
          if (currentStep === steps.length - 1) {
            setIsOpen(false);
          }
          setCurrentStep((s) => (s === steps.length - 1 ? 0 : s + 1));
        }
      }}
      disableInteraction
    >
      {children}
    </ReactTourProvider>
  );
}
